import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const token = localStorage.getItem('developers_token');

  if (token) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('HTTP Error:', error.status, error.url, error.error);
      if (error.status === 401 && !req.url.includes('/auth/me') && !req.url.includes('/auth/callback')) {
        localStorage.removeItem('developers_token');
        router.navigate(['/']);
      }
      return throwError(() => error);
    }),
  );
};
